const HCookiesStore = {
    host: publicConfiguration.getCookieStoreDomain(),
    remove(key) {
        document.cookie = key + '=;path=/;domain=' + this.host + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
    },
    put(key, value, expiryDays, codec) {
        if (value === undefined) {
            this.remove(key)
        } else {
            let expires = '';
            if (expiryDays) {
                const d = new Date();
                d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
                expires = ";expires=" + d.toUTCString();
            }
            const valueToStore = codec ? encodeURIComponent(JSON.stringify(value)) : value;
            document.cookie = key + '=' + valueToStore + ';path=/;domain=' + this.host + expires;
        }
    },
    get(key, codec) {
        let name = `${key}=`;
        let decodedCookie = decodeURIComponent(document.cookie);
        let cookies = decodedCookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trimStart().trimEnd();
            if (cookie?.indexOf(name) === 0) {
                const value = cookie.substring(name.length, cookie.length);
                return codec ? JSON.parse(decodeURIComponent(value)) : value;
            }
        }
    }
};

if (typeof window !== "undefined") {
    window.HCookiesStore = HCookiesStore;
}
